export const APIStatus = {
  IDLE: 'idle',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  EXPIRED: 'expired',
  FAILED: 'failed',
  ERROR: 'error',
} as const;

export type APIStatus = (typeof APIStatus)[keyof typeof APIStatus];
